import { render, staticRenderFns } from "./claimList.vue?vue&type=template&id=06919448&scoped=true&"
import script from "./claimList.vue?vue&type=script&lang=js&"
export * from "./claimList.vue?vue&type=script&lang=js&"
import style0 from "./claimList.vue?vue&type=style&index=0&id=06919448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06919448",
  null
  
)

export default component.exports